/**
 * RE-35, every wait shows it is working (Matthew, 27 October): the one
 * spinner the whole app uses - beside a busy button's "Saving…", a loading
 * page's "Loading…", a search's "Searching…". CSS only (styles/progress.css),
 * tokens only; with reduced motion it pulses instead of turning. Hidden from
 * screen readers: the words beside it carry the meaning.
 */
export function Spinner() {
  return <span className="spinner" aria-hidden="true" />;
}
